// TODO: TS: check ts

export const convertDatetimeStringToDate = (datetimeString: null | string | undefined): string | undefined => {
  if (!datetimeString) return;
  const datetime = new Date(datetimeString);

  const day = datetime.getDate().toString().padStart(2, "0");
  const month = (datetime.getMonth() + 1).toString().padStart(2, "0");
  const year = datetime.getFullYear().toString();
  const hour = datetime.getHours().toString().padStart(2, "0");
  const minute = datetime.getMinutes().toString().padStart(2, "0");

  return `${day}/${month}/${year} ${hour}:${minute}`;
};

export const nDaysOld = (datetimeString: null | string | undefined): string | undefined => {
  if (!datetimeString) return;

  const datetime = new Date(datetimeString);

  const today = new Date();
  const differenceInMilliseconds = today.getTime() - datetime.getTime();
  const differenceInDays = Math.floor(differenceInMilliseconds / (1000 * 60 * 60 * 24));
  return `${differenceInDays} days ago`;
};

export const dateDifference = (
  date1: Date | number | string,
  date2: Date | number | string
): { remainingDays: number; yearsDifference: number } => {
  let d1 = new Date(date1);
  let d2 = new Date(date2);

  if (d1 > d2) [d1, d2] = [d2, d1];

  const yearsDifference = d2.getFullYear() - d1.getFullYear();

  const sameDayOnGreaterYear = new Date(d1);
  sameDayOnGreaterYear.setFullYear(d1.getFullYear() + yearsDifference);

  if (sameDayOnGreaterYear <= d2) {
    const diffInMs = d2.getTime() - sameDayOnGreaterYear.getTime();
    const remainingDays = Math.round(diffInMs / (1000 * 60 * 60 * 24));
    return { remainingDays, yearsDifference };
  } else {
    const sameDayOnLastYear = new Date(d1);
    sameDayOnLastYear.setFullYear(d1.getFullYear() + yearsDifference - 1);
    const diffInMs = d2.getTime() - sameDayOnLastYear.getTime();
    const remainingDays = Math.round(diffInMs / (1000 * 60 * 60 * 24));
    return { remainingDays, yearsDifference: yearsDifference - 1 };
  }
};

export const dateDifferenceString = ({
  remainingDays,
  yearsDifference,
}: {
  remainingDays: number;
  yearsDifference: number;
}): string => {
  if (yearsDifference > 0) {
    return `${yearsDifference} year(s)` + (remainingDays > 0 ? ` and ${remainingDays} day(s)` : "");
  }
  return `${remainingDays} day(s)`;
};

export const weekDayMapping: Record<number, string> = {
  0: "Sun",
  1: "Mon",
  2: "Tue",
  3: "Wed",
  4: "Thu",
  5: "Fri",
  6: "Sat",
};

export const monthNumberMapping: Record<number, string> = {
  0: "Jan",
  1: "Feb",
  2: "Mar",
  3: "Apr",
  4: "May",
  5: "Jun",
  6: "Jul",
  7: "Aug",
  8: "Sep",
  9: "Oct",
  10: "Nov",
  11: "Dec",
};

export const getWeekdayNumber = (weekdayString: string): string | undefined => {
  return Object.keys(weekDayMapping).find((dayNum) => weekDayMapping[Number(dayNum)] === weekdayString);
};

export const getWeekdayString = (weekdayInteger: number): string | undefined => {
  return weekDayMapping[weekdayInteger];
};

export const getMonthNumber = (monthString: string): string | undefined => {
  return Object.keys(monthNumberMapping).find((monthNum) => monthNumberMapping[Number(monthNum)] === monthString);
};

export const getMonthString = (monthNumber: number): string | undefined => {
  return monthNumberMapping[monthNumber];
};

export const convertYearMonthToValidDate = (dateStr: string): Date => {
  return new Date(dateStr + " 01");
};

export const dateToUCTDatetime = (date: Date): Date =>
  new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), 0, 0, 0);

export const dateToDateString = (date: Date | null | undefined): string | undefined => {
  if (!date) return;
  return date.toISOString().split("T")[0];
};

export const yearToDateString = (year: null | number | undefined): string | undefined => {
  if (!year) return;
  return `${year}-01-01`;
};

export const dateStringToYear = (dateString: null | string | undefined): number | undefined => {
  if (!dateString) return;
  return parseInt(dateString.split("-")[0]);
};
